module.exports = __webpack_public_path__ + "img/combo_5.6c569b07.png";